import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MarcaVeiculoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getMarcasVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/marcasveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMarcaVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/marcasveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaMarcaVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/marcasveiculo', {
				marca_veiculo_nome: data.marca_veiculo_nome,
				status: '1'
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaMarcaVeiculo(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/marcasveiculo/' + data.marca_veiculo_id, {
				marca_veiculo_nome: data.marca_veiculo_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaMarcaVeiculo(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/marcasveiculo/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaMarcaVeiculoStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/marcasveiculo/' + data.marca_veiculo_id, {
				status: data.status,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMarcasVeiculoAtivas(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/marcasveiculoAtivas' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
